import { render, staticRenderFns } from "./ProfileEditView.vue?vue&type=template&id=69f6f2b1&"
import script from "./ProfileEditView.vue?vue&type=script&lang=js&"
export * from "./ProfileEditView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditView.vue?vue&type=style&index=0&id=69f6f2b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QBtn})
